import queryString from 'query-string'
import getFirstSubtestId from './getFirstSubtestId'
import devMode from '../../config/devMode'
import { type } from 'os';


export default function getSidebar(user, search, path, params, userAssessment, licenses) {
  const role = user.role
  let query = ''
  let assessmentDashboardPath = `/assessment/dashboard/6e60eb20-172e-11e8-8bfb-cb0010808928`
  const qs = queryString.parse(search)
  let newQuery = {}
  let subtestId, userAssessmentId
  if (qs.gua) {
    newQuery.gua = qs.gua
  }
  if (qs.s) {
    newQuery.s = qs.s
  }
  if (path.indexOf('/assessment/reports') > -1 || path.indexOf('/assessment/testing') > -1) {
    if (user.role !== 'Student') {
      newQuery.gua = params.gua
    }
    subtestId = params.c
    userAssessmentId = params.gua
  } else if (userAssessment) {
    userAssessmentId = userAssessment.userAssessmentId
    subtestId = getFirstSubtestId(userAssessment)
  }


  let licenseGUA = '';


  if (role !== 'Student') {
    if (role === 'Super Administrator') {
      // refactor: needs to use something like findFirstSuperAdminGUA to dynamically do this
      newQuery.gua = 'c85d02d0-2ff2-11e8-bb3c-cb20d31ae9b7'
      licenseGUA = '?gua=c85d02d0-2ff2-11e8-bb3c-cb20d31ae9b7'
    } else if (role === 'School Admin') {
      newQuery.gua = user.school
      licenseGUA = `?gua=${user.school}`
    } else if (role === 'District Admin') {
      newQuery.gua = user.schoolDistrict
      licenseGUA = `?gua=${user.schoolDistrict}`
    } else if (role === 'Teacher') {
      newQuery.gua = user.id
      licenseGUA = `?gua=${user.id}`
    }
  }


  const nq = queryString.stringify(newQuery)
  if (nq) {
    assessmentDashboardPath = `${assessmentDashboardPath}?${nq}`
  }
  let assessmentReportPath = `/assessment/reports/${userAssessmentId}/${subtestId}`
  let assessmentItemPath = `/assessment/testing/${userAssessmentId}/${subtestId}?item=overview`



  if (role === 'Super Administrator') {
    return {
      items: [
        {
          name: 'My Profile',
          url: '/profile',
          icon: 'icon-speedometer',
        },
        {
          title: true,
          name: 'Admin',
          wrapper: {
            element: '',
            attributes: {}
          },
          class: ''
        },
        {
          name: 'Users',
          url: '/users',
          icon: 'icon-people',
          children: [
            {
              name: 'Manage Users',
              url: '/users/manage',
              icon: 'fa fa-building',
            },
            // {
            //   name: 'Students',
            //   url: '/users/students',
            //   icon: 'icon-people'
            // },
            {
              name: 'Licenses',
              url: '/users/licenses/districts',
              icon: 'icon-people'
            },
            {
              name: 'Dev',
              url: '/users/dev',
              icon: 'icon-people'
            },
            // {
            //   name: 'Create Users',
            //   url: '/users/create',
            //   icon: 'icon-user-follow'

            // },
            // {
            //   name: 'Send Invites',
            //   url: '/users/invite',
            //   icon: 'icon-paper-plane'
            // },
            // {
            //   name: 'Manage Groups',
            //   url: '/users/groups',
            //   icon: 'icon-list'
            // }
          ]
        },
        {
          name: 'Content',
          url: '/content',
          icon: 'icon-note',
          children: [
            {
              name: 'Create Content',
              url: '/content/create',
              icon: 'icon-pencil',
            },
            {
              name: 'Manage Content',
              url: '/content/manage',
              icon: 'icon-book-open',
            },
            {
              name: 'Manage Sets',
              url: '/content/sets',
              icon: 'icon-grid',
            },
            {
              name: 'Knowledge Map',
              url: '/content/knowledge-map',
              icon: 'icon-share',
            }
          ]
        },
        // {
        //   name: 'Assignments',
        //   url: '/assignments',
        //   icon: 'icon-drawer',
        //   children: [
        //     {
        //       name: 'Manage Assignments',
        //       url: '/assignments/manage',
        //       icon: 'icon-notebook'
        //     },
        //     {
        //       name: 'View Assignments',
        //       url: '/assignments/view',
        //       icon: 'icon-graduation',
        //     },
        //   ]
        // },
        {
          name: 'Practice Testing',
          url: '/assessment',
          icon: 'icon-graduation',
          children: [
            {
              name: 'ACT Practice Test 17A',
              url: assessmentDashboardPath,
              icon: 'icon-calculator',
            }
          ]
        },
      ]
    }
  } else if (role === 'District Admin' || role === 'School Admin') {
    let sidebar = {
      items: [
        {
          name: 'My Profile',
          url: '/profile',
          icon: 'icon-speedometer',
        },
        {
          name: 'Manage Users',
          url: '/users/manage',
          icon: 'icon-people',
          // children: [
          //   {
          //     name: 'Educators',
          //     url: '/users/educators',
          //     icon: 'fa fa-building',
          //   },
          //   {
          //     name: 'Students',
          //     url: '/users/students',
          //     icon: 'icon-people'
          //   },
          //   {
          //     name: 'Dev',
          //     url: '/users/dev',
          //     icon: 'icon-people'
          //   },
          // ]
        },
        // {
        //   name: 'ACT Practice Test 17A',
        //   url: assessmentDashboardPath,
        //   icon: 'icon-calculator',
        // },
        ...Array.from(licenses).map(license => {
          return {
            name: license.navName,
            url: `/assessment/dashboard/${license.licenseSet}${licenseGUA}`,
            icon: 'icon-calculator',
          }
        }),
        {
          name: 'Help',
          url: '/help'
        }
        // {
        //   name: 'Test',
        //   url: '/assessment',
        //   icon: 'icon-graduation',
        //   children: [
        //     {
        //       name: 'ACT Practice Test 17A',
        //       url: assessmentDashboardPath,
        //       icon: 'icon-calculator',
        //     }
        //   ]
        // },
      ]
    }
    // if (devMode) {
    //   sidebar.items.push({
    //     name: 'Dev',
    //     url: '/users/dev',
    //     icon: 'icon-people'
    //   })
    // }
    return sidebar
  } else if (role === 'Teacher') {
    let sidebar = {
      items: [
        {
          name: 'My Profile',
          url: '/profile',
          icon: 'icon-speedometer',
        },
        {
          name: 'Students & Classes',
          url: '/users/manage/',
          icon: 'icon-list',
        },
        // {
        //   name: 'Students',
        //   url: '/users/manage/students',
        //   icon: 'icon-people'
        // },
        // {
        //   name: 'Dev',
        //   url: '/users/dev',
        //   icon: 'icon-people'
        // },
        // {
        //   name: 'ACT Practice Test 17A',
        //   url: assessmentDashboardPath,
        //   icon: 'icon-calculator',
        // },
        ...Array.from(licenses).map(license => {
          return {
            name: license.navName,
            url: `/assessment/dashboard/${license.licenseSet}${licenseGUA}`,
            icon: 'icon-calculator',
          }
        }),
        {
          name: 'Help',
          url: '/help'
        }
        // {
        //   name: 'Test',
        //   url: '/assessment',
        //   icon: 'icon-graduation',
        //   children: [
        //     {
        //       name: 'ACT Practice Test 17A',
        //       url: assessmentDashboardPath,
        //       icon: 'icon-calculator',
        //     }
        //   ]
        // },
      ]
    }
    // if (devMode) {
    //   sidebar.items.push({
    //     name: 'Dev',
    //     url: '/users/dev',
    //     icon: 'icon-people'
    //   })
    // }
    return sidebar
  } else if (role === 'Student') {
    let sidebar = {
      items: [
        {
          name: 'My Profile',
          url: '/profile',
          icon: 'icon-speedometer',
        },
        // {
        //   name: 'ACT Practice Test 17A',
        //   url: assessmentDashboardPath,
        //   icon: 'icon-calculator',
          
          
          // children: [
          //   {
          //     name: 'Overview',
          //     url: assessmentDashboardPath,
          //     icon: null,
          //   },
          //   {
          //     name: 'Skill Report',
          //     url: assessmentReportPath,
          //     icon: '',
          //   },
          //   {
          //     name: 'Item Report',
          //     url: assessmentItemPath,
          //     icon: '',
          //   }
          // ]
        // },
        ...Array.from(licenses).map(license => {
          return {
            name: license.navName,
            url: `/assessment/dashboard/${license.licenseSet}${licenseGUA}`,
            icon: 'icon-calculator',
          }
        }),
        {
          name: 'Help',
          url: '/help',
          icon: 'icon-speedometer',
        }
      ]
    }
    // if (devMode) {
    //   sidebar.items.push({
    //     name: 'Dev',
    //     url: '/users/dev',
    //     icon: 'icon-people'
    //   })
    // }
    return sidebar
  }
}


// WEBPACK FOOTER //
// ./src/helpers/nav/getSidebar.js